import {
    AfterContentInit,
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    Input,
    NgZone,
    OnDestroy,
    OnInit
} from '@angular/core';

import { BaseComponent } from '@ridango/core';

import { filter, takeUntil } from 'rxjs/operators';

import { LatLngType, MapApiService, MarkerType } from '../services';
import { MapIconComponent } from './map-icon.component';
import { MapPopupComponent } from './map-popup.component';

@Component({
    selector: 'rwidget-map-marker',
    template: ``,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapMarkerComponent extends BaseComponent implements OnInit, OnDestroy, AfterContentInit {
    private mapReady$ = this.mapApi.mapReady().pipe(filter((ready) => ready));

    private marker: MarkerType;

    private latlng: LatLngType = { lat: 0, lng: 0 };

    @Input() set latitude(lat: number) {
        this.latlng.lat = lat;
        if (this.marker) {
            this.marker.setLatLng(this.latlng);
        }
    }

    @Input() set longitude(lng: number) {
        this.latlng.lng = lng;
        if (this.marker) {
            this.marker.setLatLng(this.latlng);
        }
    }

    @Input() icon: string;
    @Input() zIndex: number;

    @Input() divIcon: any;

    /**
     * Set to true if the marker is not a part of layer.
     */
    @Input() isSingle = false;

    @ContentChild(MapPopupComponent) popupComponent: MapPopupComponent;

    @ContentChild(MapIconComponent) mapIconComponent: MapIconComponent;

    constructor(
        private mapApi: MapApiService,
        private zone: NgZone
    ) {
        super();
    }

    ngOnInit(): void {
        this.zone.runOutsideAngular(() => {
            this.marker = this.mapApi.createMarker(this.latlng);

            if (this.zIndex) this.marker.setZIndexOffset(this.zIndex);
        });
    }

    ngAfterContentInit(): void {
        this.mapReady$.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => this.init());
    }

    ngOnDestroy(): void {
        this.zone.runOutsideAngular(() => this.mapApi.removeLayer(this.marker));
        super.ngOnDestroy();
    }

    private init(): void {
        this.zone.runOutsideAngular(() => {
            const myIcon = this.mapIconComponent.getIcon();

            if (!myIcon) {
                throw new Error('rwidget-marker must contain rwidget-icon');
            }

            this.mapApi.setMarkerIcon(this.marker, myIcon);
            this.bindPopup();

            if (this.isSingle) {
                this.mapApi.addToMap(this.marker);
            }
        });
    }

    private bindPopup(): void {
        if (this.popupComponent) {
            this.popupComponent.setHostMarker(this.marker);
        }
    }

    getMarker(): MarkerType {
        return this.marker;
    }

    getLatLng(): LatLngType {
        return this.latlng;
    }
}
